import { httpClient } from '@/modules/common/services/http/http-client';
import { TGetCustomerSummaryResponse, TGetLeadSummaryResponse } from './types';

export const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_API_BFF_PARTNER_URL}/v1/partner/`
});

export function getLeadSummary(
  leadId: string
): Promise<TGetLeadSummaryResponse> {
  return http.get(`lead/${leadId}/summary`);
}

export function getCustomerSummary(
  customerId: string
): Promise<TGetCustomerSummaryResponse> {
  return http.get(`customer/${customerId}/summary`);
}
